import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_PHOTO_UPLOAD_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_PHOTO_UPLOAD_REQUEST`;
export const PHOTO_CAPTURE_PHOTO_UPLOAD_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_PHOTO_UPLOAD_SUCCESS`;
export const photoCapturePhotoUploadAction = (contextId, coCode, sourceName) => ({
    type: PHOTO_CAPTURE_PHOTO_UPLOAD_REQUEST,
    payload: { contextId, coCode, sourceName }
});
export const photoCapturePhotoUploadSuccessAction = response => ({
    type: PHOTO_CAPTURE_PHOTO_UPLOAD_SUCCESS,
    payload: response
});
//# sourceMappingURL=photoCapturePhotoUploadAction.js.map